import React from "react";
import "../Styles/About.css";

function About() {
  const sectionStyle = {
    padding: '60px 20px',
    textAlign: 'center',
    backgroundColor: '#fff',
    color: '#333',
  };

  const headingStyle = {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '10px',
  };

  const subTextStyle = {
    fontSize: '16px',
    color: '#666',
    marginBottom: '50px',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    maxWidth: '100%',
    margin: '0 auto',
  };

  const cardStyle = {
    flex: '1 1 220px',
    maxWidth: '320px',
    border: '1px solid #000',
    padding: '30px',
    boxSizing: 'border-box',
    borderRadius: '8px',
  };

  const iconStyle = {
    height: '60px',
    marginBottom: '20px',
  };

  const cardTitleStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '10px',
  };

  const cardTextStyle = {
    color: '#555',
    fontSize: '14px',
  };

  const cards = [
    {
      icon: 'https://demo-63.woovinapro.com/wp-content/uploads/2020/12/electrocardiogram.png',
      title: 'Emergency',
      text: 'Sed ut perspiciatis unde omnis iste voluptatem accusantium',
    },
    {
      icon: 'https://demo-63.woovinapro.com/wp-content/uploads/2020/12/first-aid-kit.png',
      title: 'Emergency',
      text: 'Sed ut perspiciatis unde omnis iste voluptatem accusantium',
    },
    {
      icon: 'https://demo-63.woovinapro.com/wp-content/uploads/2020/12/cell.png',
      title: 'Emergency',
      text: 'Sed ut perspiciatis unde omnis iste voluptatem accusantium',
    },
    {
      icon: 'https://demo-63.woovinapro.com/wp-content/uploads/2020/12/pharmacy.png',
      title: 'Emergency',
      text: 'Sed ut perspiciatis unde omnis iste voluptatem accusantium',
    },
  ];

  return (
    <main className="site-main clr">
      <div
        className="bg-cover bg-center h-64 flex flex-col justify-center items-center text-center"
        style={{
          backgroundImage: "url('https://i.ibb.co/1fSyDjVZ/background-page-title.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "80px 0",
          color: "#000",
        }}
      >
        <h1 className="text-4xl font-bold text-gray-800">About Us</h1>
        <p className="text-gray-700 mt-2">
          Home <span className="font-bold">› About Us</span>
        </p>
      </div>

      <section className="about-section">
        <div className="about-text-block">
          <h2>ABOUT US</h2>
          <p className="about-desc">
            AllDayGeneric is much more than simply a regular health store! We are one of the leading pharmacies on the Internet for distributing generic drugs and OTC healthcare items since 2014, and we are now expanding our network worldwide to provide quality service and products to consumers.
          </p>
          <p className="about-desc">
            While visiting our online drugstore or placing an order, you’ll find nearly every popular medication available at great savings. You never have to compromise on quality or reliability from our Best Online Pharmacy. Our professional team is headed by a top-rated qualified Indian pharmacist, offering only the best value in generic drugs and brands. This is why our existing customers return time and again.
          </p>
          <p className="about-desc">
            Each product available through our website is produced using top-quality raw materials at world-class pharmaceutical manufacturing plants in India—approved by the Indian FDA and internationally certified. Most medications found on AllDayGeneric require a prescription from a licensed physician, which must be submitted via fax or scan before we can process the order.
          </p>

          <h3>SERVICE STANDARDS</h3>
          <p className="about-desc">
            A Quality Audit Team regularly monitors all drugs and orders to ensure adherence to our strict standards—providing the best service and experience to every customer. We follow up-to-date guidelines that guarantee your safety and privacy.
          </p>


        </div>

        <div className="about-img-block">
          <img src="https://i.ibb.co/tTms3pBf/image.png" alt="Doctor with elderly" />
        </div>
      </section>

      <section className="about-section-desin">
        <div className="about-img-block">
          <img src="https://i.ibb.co/CsV3FZ01/Vector-Smart-Object.png" alt="Medical Staff" />
        </div>
        <div className="about-text-block" style={{ marginLeft: "60px" }}>
  <h2>Learn About Our Birth History & Our Mission</h2>
  <p className="about-desc">
    Contrary to popular belief, Lorem Ipsum’s not simply random text. It has roots in classical Latin literature.
  </p>

  <p className="about-subtitle">Our Vision</p>
  <p className="about-desc">
    Richard Clintock, Latin professor at Hampden-Sydney College, looked up one of the Latin words and found the undoubtable source.
  </p>

  <p className="about-subtitle">Choice of Products and Availability</p>
  <p className="about-desc">
    Products that appear on the AllDayGeneric website must pass stringent evaluation parameters before approval. Market studies are conducted for every product prior to listing. Evaluations include manufacturer analysis and packaging standards.
    Most products on our site are generic drugs—offering the same ingredients and effectiveness as their branded counterparts, but at significantly lower prices.
    These affordable alternatives maintain the same purity, potency, dosage, and bio-equivalence.
    India, the leader in global generic drug production, hosts 74% of USFDA-approved generic drug facilities outside the US.
  </p>

  <p className="about-subtitle">Discreet Delivery</p>
  <p className="about-desc">
    We ensure all orders are shipped in recycled, environmentally friendly, discreet boxes or mailers to respect your privacy—just as a local pharmacy would provide your medication in a sealed, non-see-through bag. We take your privacy seriously.
  </p>

  <p className="about-subtitle">Your Privacy</p>
  <p className="about-desc">
    Your privacy is our top priority. We never misuse your personal data or email address. We strictly avoid any spam activities.
    If you ever receive unsolicited messages related to our products, please contact our support team and we’ll take immediate action.
  </p>

  <p className="about-subtitle">Security of Ordering</p>
  <p className="about-desc">
    We understand your concern regarding online scams and fake websites. That’s why AllDayGeneric is a Trusted Online Drugstore.
    All shopping cart pages are secured with a valid SSL Certificate and powered by Alpha SSL and Sucuri Security.
    You can be confident that your personal and payment data is fully protected while shopping with us.
  </p>
</div>

      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>What We Do</h2>
        <p style={subTextStyle}>
          It is established fact that a reader will be distracted by the readable content
        </p>
        <div style={containerStyle}>
          {cards.map((card, index) => (
            <div style={cardStyle} key={index}>
              <img src={card.icon} alt="icon" style={iconStyle} />
              <h3 style={cardTitleStyle}>{card.title}</h3>
              <p style={cardTextStyle}>{card.text}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default About;
